import { Component, OnInit,  EventEmitter, Output } from '@angular/core';
import * as moment from 'moment';
import {NgbDate, NgbCalendar, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { Seleccionfechas } from 'src/app/models/seleccionfechas';


// este se debe declarar en app.module en declaraciones y entrycomponets
// para cambiar el comportamiento del formulario y aparezca como ventana de dialogo

@Component({
  selector: 'app-rangofecha',
  templateUrl: './rangofecha.component.html',
  styleUrls: ['./rangofecha.component.css']
})
export class RangofechaComponent implements OnInit {


  @Output() public Rangofechas = new EventEmitter<any>();





  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate | null;
  toDate: NgbDate | null;





  constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
  }

  ngOnInit() {

  }



  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
      console.log ('fcha actual1', this.fromDate);
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
      console.log ('fcha actual2', this.toDate);
    } else {
      this.toDate = null;
      this.fromDate = date;
      console.log ('fcha actual1', this.fromDate);
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }


  pasafechas() {

  this.Rangofechas.emit ({iniciofecha: new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day),
    finfecha: new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day)})
  }

}
